export const BOOT = 'BOOTING';

export const boot = () => ({
  type: BOOT
});
